<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', `Facturation`)
</script>

<template>
  <q-page flex> Facturation </q-page>
</template>
